import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    
    if (!isHomePage) {
      window.location.href = `/#${id}`;
      return;
    }
    
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleGetStarted = () => {
    if (!isHomePage) {
      window.location.href = '/#contact';
      return;
    }
    scrollToSection('contact');
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-3 cursor-pointer">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center shadow-lg transition-colors ${
              isScrolled ? 'bg-[#0F3A2E]' : 'bg-white'
            }`}>
              <span className={`font-bold text-xl transition-colors ${
                isScrolled ? 'text-white' : 'text-[#0F3A2E]'
              }`}>PP</span>
            </div>
            <div className="flex flex-col">
              <span className={`text-xl font-bold leading-tight transition-colors ${
                isScrolled ? 'text-[#0F3A2E]' : 'text-white'
              }`}>Providence Path</span>
              <span className={`text-xs font-medium transition-colors ${
                isScrolled ? 'text-gray-600' : 'text-white/80'
              }`}>Faith-Driven Growth</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0F3A2E]' : 'text-white hover:text-[#C9A24D]'
              }`}
            >
              About Us
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0F3A2E]' : 'text-white hover:text-[#C9A24D]'
              }`}
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#0F3A2E]' : 'text-white hover:text-[#C9A24D]'
              }`}
            >
              Testimonials
            </button>
            <button
              onClick={handleGetStarted}
              className="px-6 py-3 bg-[#C9A24D] text-[#0F3A2E] font-bold rounded-full hover:bg-[#B8963E] transition-all whitespace-nowrap cursor-pointer shadow-lg"
            >
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isScrolled ? 'text-[#0F3A2E] hover:bg-gray-100' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4 shadow-lg">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('about')}
                className="text-sm font-semibold text-gray-700 hover:text-[#0F3A2E] transition-colors cursor-pointer text-left px-4 whitespace-nowrap"
              >
                About Us
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="text-sm font-semibold text-gray-700 hover:text-[#0F3A2E] transition-colors cursor-pointer text-left px-4 whitespace-nowrap"
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="text-sm font-semibold text-gray-700 hover:text-[#0F3A2E] transition-colors cursor-pointer text-left px-4 whitespace-nowrap"
              >
                Testimonials
              </button>
              <button
                onClick={handleGetStarted}
                className="mx-4 px-6 py-3 bg-[#C9A24D] text-[#0F3A2E] font-bold rounded-full hover:bg-[#B8963E] transition-all whitespace-nowrap cursor-pointer text-center"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
